export * from 'js/components/tagTypes/MFA/constants';

export const MISSING_HOSTNAME = 'MISSING_HOSTNAME';
export const INCORRECT_CONFIGURATION = 'INCORRECT_CONFIGURATION';
export const NO_SDK_ERROR = 'NO_SDK_ERROR';
export const UNICO_SDK_MODULE = Symbol.for('UNICO_SDK_MODULE');
export const UNICO_SDK_PROMISE = Symbol.for('UNICO_SDK_PROMISE');
